import { render, staticRenderFns } from "./ivr-gateways.vue?vue&type=template&id=a3914ce6&"
import script from "./ivr-gateways.vue?vue&type=script&lang=js&"
export * from "./ivr-gateways.vue?vue&type=script&lang=js&"
import style0 from "./ivr-gateways.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports